var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIntegrations = function SvgIntegrations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 0c14.36 0 26 11.64 26 26v28H91c-19.683 0-35.677 15.797-35.995 35.405L55 90v42H26c-14.36 0-26-11.64-26-26V26C0 11.64 11.64 0 26 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 68c14.36 0 26 11.64 26 26v80c0 14.36-11.64 26-26 26H94c-14.36 0-26-11.64-26-26V94c0-14.36 11.64-26 26-26zm-11 22h-58c-8.284 0-15 6.716-15 15v58c0 8.284 6.716 15 15 15h58c8.284 0 15-6.716 15-15v-58c0-8.284-6.716-15-15-15",
    opacity: 0.25
  }))));
};
export default SvgIntegrations;